module.exports = __webpack_public_path__ + "static/media/avatar.5b412e2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/avatar.svg
// module id = 1013
// module chunks = 0